import { Reducer, Action } from 'redux';
import { AppState, getInitialAppState } from '@app/redux/states';
import Reducers from './Reducers';

export const AppReducer: Reducer<AppState, Action> = (state: AppState = getInitialAppState(), action: Action): AppState => {
	let reducerOperation = Reducers[action.type];
	if (reducerOperation) {
		return reducerOperation(state, action);
	}
	return state;
}